import React from 'react';
import { FormName, isSubmitting } from 'redux-form';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ButtonProps } from 'antd/lib/button/button';

import { RootState } from 'app/redux';

import { FormButtonProps } from './form-button-props';

interface OwnProps {
    component: React.ComponentType<FormButtonProps>;
}

interface StateProps {
    submitting: boolean;
}

interface FormNameProps {
    form: string;
}

type Props = FormButtonProps & OwnProps & StateProps & FormNameProps & { dispatch: Dispatch };

const FormButtonComponent: React.FC<Props> = (props: Props) => {
    const { component: Component, ...rest } = props;

    return <Component {...rest} />;
};

const mapStateToProps = (state: RootState, ownProps: OwnProps & FormNameProps): StateProps => {
    const { form: formName } = ownProps;

    return {
        submitting: isSubmitting(formName)(state),
    };
};

const ConnectedFormButton = connect(mapStateToProps)(FormButtonComponent);

const FormButton = (props: ButtonProps & OwnProps): React.ReactElement => (
    <FormName children={({ form }) => <ConnectedFormButton form={form} {...props} />} />
);

export { FormButton };
